import { FC } from 'react';
import { SwitchPropsTypes } from '../types/SwitchProps';
import { Theme } from '../../../types/enums';
import styles from './Switch.module.scss';

const Swicth: FC<SwitchPropsTypes> = ({ text, isActive, disabled, theme = Theme.GREEN, ...restProps }: SwitchPropsTypes) => (
  <label role="presentation" className={`${styles['switch']}`}>
    <input
      type="checkbox"
      checked={disabled ? false : isActive}
      name={text}
      id={text}
      disabled={disabled}
      data-testid="switch-test-id"
      {...restProps}
    />
    <span className={`${styles['slider']} ${styles['round']} ${styles[theme]}`}></span>
    <span className={`${styles['checkmark']}`}></span>
    <span className={styles['text']}>{text}</span>
  </label>
);

export default Swicth;
